import axios from 'axios';
import auth from './auth';
import { errorHandler, ignoreErrorHandler } from 'app/utils/errorHandler';

//process.env.NODE_ENV === "development" ? "" : "";
export const stipBaseUrl = '/stip-transporte-backend';
export const stipReportBaseUrl = '/stip-report';
export const bunchBaseUrl = '/bunch-backend/api/v1';

// Common config
const requestInterceptor = async config => {
  const token = await auth.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};
const responseInterceptor = response => {
  return response;
};

const interceptorRequestCallback = err => {
  let message =
    err.response?.data?.message ||
    err.response?.statusText ||
    err.message ||
    'Erro ao processar requisição';
  if (message === 'Internal Server Error') {
    message = 'Erro ao acessar informação.';
  }
  errorHandler(err.response?.status, message);
  return Promise.reject(err);
}

const interceptorResponseCallback = err => {
  const url = err.response?.config?.url;
  if (url && !ignoreErrorHandler.includes(url)) {
    let message = err.response?.data?.message || err.response?.statusText || err.message || 'Erro ao processar requisição';
    if (err.request.responseType === 'arraybuffer') {
      try {
        const res = JSON.parse(Buffer.from(err.response.data).toString('utf8'));
        if (res.message) message = res.message;
      } catch (e) {
        console.error(e);
      }
    }
    if (message === 'Internal Server Error') {
      message = 'Erro ao acessar informação.';
    }
    errorHandler(err.response?.status, message);
  }
  return Promise.reject(err);
}

const stipAxios = axios.create({ baseURL: stipBaseUrl });
stipAxios.interceptors.request.use(requestInterceptor, interceptorRequestCallback);
stipAxios.interceptors.response.use(responseInterceptor, interceptorResponseCallback);

const stipReportAxios = axios.create({ baseURL: stipReportBaseUrl });
stipReportAxios.interceptors.request.use(requestInterceptor, interceptorRequestCallback);
stipReportAxios.interceptors.response.use(responseInterceptor, interceptorResponseCallback);

export { stipAxios, stipReportAxios };
